﻿import Vue from 'vue';
import 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

import basketMixin from '../core/basket'
import accordionSection from '../components/accordion-section'
import cityAutocomplete from '../components/city-autocomplete'
import streetAutocomplete from '../components/street-autocomplete'

Vue.component('accordion-section', accordionSection);
Vue.component('city-autocomplete', cityAutocomplete);
Vue.component('street-autocomplete', streetAutocomplete);

var mainVM = new Vue({
    mixins: [basketMixin],
    el: '#mainApp',
    data: {
        currentSection: getParameterByName("section") != "" ? getParameterByName("section") : "checkout-customer",
        pageErrors: [],
        customerModel: window.customerModel,
        shippingAddressModel: window.shippingAddressModel,
        shippingMethodModel: window.shippingMethodModel,
        paymentMethodType: window.paymentMethodType,
        paymentMethodSystemName: "",
        showCheckoutButton: true,
        royaltyDiamondPromotion: window.royaltyDiamondPromotion || (window.basket != null ? window.basket.royaltyDiamondPromotion : null),
        royaltyDiamondPromotionStep: "intro",
        royaltyDiamondPromotionShown: false,
        isAddingRoyaltyDiamondPromotionGift: false
    },
    mounted: function () {
        var vm = this;
        window.onpopstate = function (e) {
            if (vm.basket.items.length == 0) {
                window.location = "/basket";
            }
            var section = "checkout-customer";
            if (e.state != null) {
                section = e.state.section;
            }
            vm.currentSection = section;
        };
        vm.syncRoyaltyDiamondPromotion();
        vm.showRoyaltyDiamondPromotion();
    },
    methods: {
        setCurrentSection: function (section) {
            this.currentSection = section;
            window.history.pushState({ section: section }, section, "?section=" + section);
        },
        saveCustomer: function (e) {
            var vm = this;
            var $form = $('#checkout-customer');
            var fieldValue = function (name, fallbackValue) {
                var $field = $form.find('[name="' + name + '"]').first();
                return $field.length > 0 ? $field.val() : fallbackValue;
            };
            var isChecked = function (name, fallbackValue) {
                var $field = $form.find('input[type="checkbox"][name="' + name + '"]').first();
                return $field.length > 0 ? $field.is(':checked') : fallbackValue;
            };
            var customerData = {
                FirstName: fieldValue('FirstName', vm.customerModel.firstName),
                LastName: fieldValue('LastName', vm.customerModel.lastName),
                CustomerGender: fieldValue('CustomerGender', vm.customerModel.customerGender),
                CustomerPhone: fieldValue('CustomerPhone', vm.customerModel.customerPhone),
                Email: fieldValue('Email', vm.customerModel.email),
                Note: fieldValue('Note', vm.customerModel.note),
                SubscribeToNewsLetter: isChecked('SubscribeToNewsLetter', vm.customerModel.subscribeToNewsLetter),
                ApproveTerms: isChecked('ApproveTerms', vm.customerModel.approveTerms),
                ApproveTermsValidationTrue: true,
                IsGift: isChecked('IsGift', vm.customerModel.isGift),
                IsBrandedBag: isChecked('IsBrandedBag', vm.customerModel.isBrandedBag)
            };

            vm.postSection("checkout-customer",
                "/checkout/savecustomer",
                $(e.currentTarget),
                function (response) {
                    vm.shippingAddressModel = response.shippingAddressModel;

                    if (vm.customerModel.subscribeToNewsLetter) {
                        flashy.contacts.create({
                            "email": vm.customerModel.email,
                            "first_name": vm.customerModel.firstName,
                            "last_name": vm.customerModel.lastName,
                            "phone": vm.customerModel.customerPhone,
                        }, 15290);
                    } else {
                        flashy.contacts.create({
                            "email": vm.customerModel.email,
                            "first_name": vm.customerModel.firstName,
                            "last_name": vm.customerModel.lastName,
                            "phone": vm.customerModel.customerPhone,
                        });
                    }
                },
                customerData
            );
        },
        saveShippingAddress: function (e) {
            var vm = this;
            vm.postSection("shipping-address",
                "/checkout/saveshippingaddress",
                $(e.currentTarget),
                function (response) {
                    vm.shippingMethodModel = response.shippingMethodModel;
                }
            );
        },
        saveShippingMethod: function (e) {
            var vm = this;
            vm.postSection("shipping-method",
                "/checkout/saveshippingmethod",
                $(e.currentTarget),
                function (response) {
                }
            );
        },
        placeOrder: function (e) {
            var vm = this;
            vm.postSection("checkout-payment",
                "/checkout/placeorder",
                $(e.currentTarget),
                function (response) {
                }
            );
        },
        showRoyaltyDiamondPromotion: function () {
            var vm = this;
            if (vm.royaltyDiamondPromotionShown ||
                vm.royaltyDiamondPromotion == null ||
                !vm.royaltyDiamondPromotion.showPopup) {
                return;
            }

            vm.royaltyDiamondPromotionShown = true;
            vm.royaltyDiamondPromotionStep = "intro";
            window.setTimeout(function () {
                var $modal = $("#royaltyDiamondPromotionModal");
                var $activeModal = $(".modal.show").not($modal);
                var showModal = function ($targetModal) {
                    if (typeof $targetModal.modal === "function") {
                        $targetModal.modal("show");
                    } else if (window.bootstrap != null && window.bootstrap.Modal != null) {
                        window.bootstrap.Modal.getOrCreateInstance($targetModal[0]).show();
                    }
                    $targetModal.css("z-index", "1085");
                    $("body").addClass("modal-open");
                };
                var hideModal = function ($targetModal) {
                    if (typeof $targetModal.modal === "function") {
                        $targetModal.modal("hide");
                    } else if (window.bootstrap != null && window.bootstrap.Modal != null) {
                        $targetModal.each(function () {
                            window.bootstrap.Modal.getOrCreateInstance(this).hide();
                        });
                    }
                };
                var cleanupHiddenModals = function () {
                    if ($(".modal.show").length == 0) {
                        $(".modal-backdrop").remove();
                        $("body").removeClass("modal-open");
                    }
                };
                var showPromotion = function () {
                    showModal($modal);
                };
                var keepPromotionVisible = function (attemptsRemaining) {
                    if ($modal.length == 0) {
                        return;
                    }

                    if (!$modal.hasClass("show")) {
                        if (attemptsRemaining > 0) {
                            window.setTimeout(function () {
                                keepPromotionVisible(attemptsRemaining - 1);
                            }, 500);
                        }
                        return;
                    }

                    $modal.css("z-index", "1085");
                    $("body").addClass("modal-open");
                    var $otherModals = $(".modal.show").not($modal);
                    if ($otherModals.length > 0) {
                        $otherModals.one("hidden.bs.modal", cleanupHiddenModals);
                        hideModal($otherModals);
                        $("body").addClass("modal-open");
                    }

                    if (attemptsRemaining > 0) {
                        window.setTimeout(function () {
                            keepPromotionVisible(attemptsRemaining - 1);
                        }, 500);
                    }
                };

                if ($modal.length == 0) {
                    return;
                }

                if ($activeModal.length > 0) {
                    $activeModal.one("hidden.bs.modal", function () {
                        window.setTimeout(function () {
                            showPromotion();
                            keepPromotionVisible(8);
                        }, 250);
                    });
                    hideModal($activeModal);
                    return;
                }

                showPromotion();
                keepPromotionVisible(8);
            }, 500);
        },
        syncRoyaltyDiamondPromotion: function () {
            var promotion = this.basket != null && this.basket.royaltyDiamondPromotion != null
                ? this.basket.royaltyDiamondPromotion
                : window.royaltyDiamondPromotion;
            if (promotion != null) {
                this.royaltyDiamondPromotion = promotion;
                window.royaltyDiamondPromotion = promotion;
            }
        },
        addRoyaltyDiamondPromotionGift: function (e) {
            var vm = this;
            var btn = $(e.currentTarget);
            if (btn.buttonIsWaiting()) {
                return;
            }

            btn.buttonWait();
            vm.isAddingRoyaltyDiamondPromotionGift = true;

            $.post({
                url: vm.URLPrefix + "/basket/addroyaltydiamondpromotiongift",
                success: function (basketView) {
                    if (basketView.basketWarnings != null && basketView.basketWarnings.length > 0) {
                        alert(basketView.basketWarnings.join("\n"));
                        return;
                    }

                    vm.basket = basketView;
                    vm.syncRoyaltyDiamondPromotion();
                    vm.royaltyDiamondPromotionShown = true;

                    var $modal = $("#royaltyDiamondPromotionModal");
                    if (typeof $modal.modal === "function") {
                        $modal.modal("hide");
                    } else if (window.bootstrap != null && window.bootstrap.Modal != null && $modal.length > 0) {
                        window.bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
                    } else {
                        $modal.removeClass("show").hide();
                    }

                    window.setTimeout(function () {
                        if ($(".modal.show").length == 0) {
                            $(".modal-backdrop").remove();
                            $("body").removeClass("modal-open");
                        }
                    }, 350);
                },
                error: function () {
                    alert("Could not add the diamond gift.");
                },
                complete: function () {
                    vm.isAddingRoyaltyDiamondPromotionGift = false;
                    btn.buttonStopWaiting();
                }
            });
        },
        selectShippingMethod: function (shippingMethod) {
            var vm = this;
            if (vm.selectedShippingMethod != null) {
                vm.selectedShippingMethod.selected = false;
            }
            shippingMethod.selected = true;
            vm.getBasket(shippingMethod.shippingOption.id);
        },
        postSection: function (name, url, btn, success, data) {
            var vm = this;
            var $form = $('#' + name);
            if (!btn.buttonIsWaiting()) {
                vm.pageErrors = [];
            }
            if (!btn.buttonIsWaiting() && $form.valid()) {
                btn.buttonWait();
                $.post({
                    url: vm.URLPrefix + url,
                    data: data != undefined ? data : $form.serialize(),
                    success: function (response) {
                        if (response.redirect != undefined && response.success == 1) {
                            window.location = response.redirect;
                        } else if (response.errors != undefined && response.errors.length > 0) {
                            vm.pageErrors = response.errors;
                        } else if (response.gotoSection != undefined) {
                            vm.setCurrentSection(response.gotoSection);
                        }
                        if (success != undefined && response.success) {
                            success(response);
                        }
                    }
                }).always(function () {
                    btn.buttonStopWaiting();
                });
            }
        },
        getHeartIcon: function (productId, srcPrefix) {
            var iconSrc = srcPrefix != undefined && srcPrefix != null && srcPrefix != "" ? srcPrefix : "/img/";
            //if (this.isWishlistItem(productId))
            //    iconSrc += "heart-icon-full.svg";
            //else
            iconSrc += "heart-icon.svg";
            return iconSrc;
        }
    },
    computed: {
        selectedShippingMethod: function (val) {
            var vm = this;
            if (vm.shippingMethodModel != null && vm.shippingMethodModel.shippingMethods != null) {
                var selectedShippingMethod = vm.shippingMethodModel.shippingMethods.filter(function (item) { return item.selected; });
                if (selectedShippingMethod.length > 0) {
                    return selectedShippingMethod[0];
                }
            }
            return null;
        }
    },
    watch: {
        basket: function () {
            this.syncRoyaltyDiamondPromotion();
        },
        paymentMethodSystemName: function (val) {
            if (val == "Payments.PayPalCommerce") {
                this.showCheckoutButton = false;
            } else {
                this.showCheckoutButton = true;
            }
        }
    }
});






function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

(function ($) {
    $.fn.extend({
        validateField: function (w, msg) {
            if (checkFieldValue(w, $(this).attr('value'), $(this).attr('placeholder'))) {
                if ($(this).parent().children('.msg').length === 0) {
                    $(this).parent().addClass('error');
                    $(this).parent().append('<span class="msg"><p>' + msg + '</p></span>');
                }
                return true;
            } else {
                $(this).parent().removeClass('error');
                $(this).parent().children('.msg').remove();
                return false;
            }
        },
        buttonWait: function () {
            if ($(this).length == 0)
                return;

            if ($(this).prop("tagName") === 'INPUT')
                $(this).addClass('preloader');

            else {
                $(this).attr('data-html', $(this).html().trim());
                $(this).css({ width: $(this).outerWidth() });
                $(this).html('<span class="btn-preloader"></span>');
            }
            $(this).attr('waiting', 'true');
        },
        buttonStopWaiting: function () {
            if ($(this).length == 0)
                return;

            if ($(this).attr('data-html') !== '')
                $(this).html($(this).attr('data-html'));

            $(this).attr('waiting', 'false');
            $(this).removeClass('preloader');
        },
        buttonIsWaiting: function () {
            if ($(this).length == 0)
                return;
            return $(this).attr('waiting') === 'true';
        }
    });
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    //lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove("lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to event handlers here
    }
});
